export default __webpack_public_path__ + "static/media/il-borgo-gallery-4--Alberto-Locatelli.59591a31.jpg";